import { PrivateField } from './PrivateField'

export default PrivateField
